import { isProduction } from "@/Environment";
import { isFreightSimpleEmployee } from "@/Helpers/isFreightSimpleEmployee";

/**
 * The iOS app hasn't shipped yet, so device pairing is hidden from customers
 * in production. Employees and non-production environments still see it.
 * Remove once the app ships — ENG-6029.
 */
export function showPairMobileDevice(email: string | undefined): boolean {
  return !isProduction() || isFreightSimpleEmployee(email);
}
